// 안전한 테마 관리 유틸리티 (무한루프 방지)

export const THEME_TYPES = {
  MODERN: 'modern',
  DOS: 'dos'
};

export const THEME_LABELS = {
  [THEME_TYPES.MODERN]: {
    ko: '모던 테마',
    en: 'Modern Theme',
    fr: 'Thème moderne'
  },
  [THEME_TYPES.DOS]: {
    ko: '도스 테마',
    en: 'DOS Theme', 
    fr: 'Thème DOS'
  }
};

// 로컬 스토리지 키
const THEME_STORAGE_KEY = 'user_theme';

// 기본 테마
const DEFAULT_THEME = THEME_TYPES.MODERN;

/**
 * 현재 테마 가져오기
 */
export const getCurrentTheme = () => {
  try {
    const storedTheme = localStorage.getItem(THEME_STORAGE_KEY);
    return storedTheme || DEFAULT_THEME;
  } catch (error) {
    console.error('테마 불러오기 실패:', error);
    return DEFAULT_THEME;
  }
};

/**
 * 테마 저장하기 (이벤트 발생 없이)
 */
export const saveThemeSilently = (theme) => {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
    console.log('테마 저장됨 (조용히):', theme);
  } catch (error) {
    console.error('테마 저장 실패:', error);
  }
};

/**
 * 테마 적용하기 (DOM에 data-theme 속성 설정 및 CSS 변수 적용)
 */
export const applyTheme = (theme) => {
  try {
    document.documentElement.setAttribute('data-theme', theme);
    
    // CSS 변수 적용
    const { applyThemeToCSS } = require('../styles/themes');
    applyThemeToCSS(theme);
    
    console.log('테마 적용됨:', theme);
  } catch (error) {
    console.error('테마 적용 실패:', error);
  }
};

/**
 * 앱 시작 시 테마 초기화
 */
export const initializeTheme = () => {
  const currentTheme = getCurrentTheme();
  applyTheme(currentTheme);
  return currentTheme;
};

/**
 * 테마 변경하기 (저장 + 적용)
 */
export const changeTheme = (theme) => {
  saveThemeSilently(theme);
  applyTheme(theme);
};

/**
 * 테마 리셋하기 (기본 테마로)
 */
export const resetTheme = () => {
  changeTheme(DEFAULT_THEME);
};

/**
 * 사용 가능한 테마 목록 가져오기
 */
export const getAvailableThemes = () => {
  return Object.values(THEME_TYPES);
};

/**
 * 테마가 유효한지 확인
 */
export const isValidTheme = (theme) => {
  return Object.values(THEME_TYPES).includes(theme);
};
